import { useLocation } from 'react-router-dom';

export const useQuery = (param) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return query.get(param);
};
